export const mealSuggestionError = code => Object.assign(new Error({
  MEAL_SUGGESTION_TIMEOUT: 'Recipe generation took too long. Please try again; your meal has not been changed.',
  reasoning_compatibility_failed: 'The recipe model could not produce a reply. Choose another Recipes model in AI settings, then retry.',
  NO_COMPATIBLE_IMAGE_MODEL: 'Choose a photo-capable model in AI settings or remove the ingredient photos.',
  meal_changed: 'This recipe request is no longer current. Please try again.',
}[code] || 'Recipe generation failed. Please try again.'), { code });

export async function runMealSuggestionRequest(start, poll, externalSignal) {
  const controller = new AbortController();
  let timer;
  let rejectAbort;
  const abort = () => { controller.abort(); rejectAbort?.(mealSuggestionError('meal_changed')); };
  const aborted = new Promise((_, reject) => { rejectAbort = reject; });
  externalSignal?.addEventListener('abort', abort, { once: true });
  if (externalSignal?.aborted) abort();
  const deadline = new Promise((_, reject) => {
    timer = setTimeout(() => { controller.abort(); reject(mealSuggestionError('MEAL_SUGGESTION_TIMEOUT')); }, 600000);
  });
  const work = async () => {
    if (controller.signal.aborted) throw mealSuggestionError('meal_changed');
    let state = await start(controller.signal);
    if (!state?.job) return state; // older backend during rolling deployment
    const id = state.job.id;
    while (!controller.signal.aborted) {
      if (state.job?.id !== id) throw mealSuggestionError('meal_changed');
      if (state.job.status === 'succeeded') return state.meal;
      if (!['pending', 'running'].includes(state.job.status)) throw mealSuggestionError(state.job.error || 'meal_changed');
      await new Promise(resolve => setTimeout(resolve, 1500));
      if (controller.signal.aborted) throw mealSuggestionError('meal_changed');
      state = await poll(controller.signal);
    }
    throw mealSuggestionError('meal_changed');
  };
  try { return await Promise.race([work(), deadline, aborted]); }
  finally { clearTimeout(timer); externalSignal?.removeEventListener('abort', abort); }
}
